import { useLang, buildWhatsAppUrl } from "../i18n";
import { useReveal } from "../hooks/useReveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { MessageCircle } from "lucide-react";

export default function FAQ() {
  const { t } = useLang();
  const r = useReveal();
  return (
    <section id="faq" data-testid="faq-section" className="relative bg-black py-24 md:py-40">
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div ref={r} className="reveal lg:col-span-5">
          <p className="overline mb-4">{t.faq.overline}</p>
          <h2
            data-testid="faq-title"
            className="font-display text-4xl sm:text-6xl lg:text-7xl uppercase tracking-tighter leading-[0.95]"
          >
            {t.faq.title}
          </h2>
          <p className="mt-6 text-white/65 max-w-md">
            <span className="font-script text-5xl md:text-6xl normal-case leading-[0.9]">
              {t.about.lead}
            </span>
          </p>
          <a
            data-testid="faq-cta"
            href={buildWhatsAppUrl(t.whatsapp_pretext)}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 btn-wa inline-flex"
          >
            <MessageCircle className="w-4 h-4" /> {t.nav.book}
          </a>
        </div>

        <div className="lg:col-span-7">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {t.faq.items.map((it, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-white/15"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left py-6 font-display text-base md:text-lg uppercase tracking-tight text-white hover:no-underline data-[state=open]:text-[hsl(var(--red-2))]">
                  {it.q}
                </AccordionTrigger>
                <AccordionContent className="text-white/70 text-base leading-relaxed pb-8 max-w-2xl">
                  {it.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
